module.exports = __webpack_public_path__ + "static/media/wordpress.43c582c5.svg";